import {
  Box,
  Heading,
  HStack,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Tr,
} from "@chakra-ui/react";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import MainModel from "../../../../components/Models/main-model";
import { closeShowAssistantDataModel } from "../../../../modules/admin-modules/models/Actions";

const ShowAssistantData = ({ data }) => {
  const openAssistantData = useSelector((state) => state.model.isOpen42);
  const dispatch = useDispatch();
  const header = (
    <Box>
      <Heading textAlign="center" color="main_1" fontSize="24px">
        بيانات الأسيستانت
      </Heading>
    </Box>
  );

  const closeFunc = () => {
    dispatch(closeShowAssistantDataModel());
  };
  return (
    <MainModel header={header} closeFunc={closeFunc} openVar={openAssistantData}>
      <TableContainer>
        <Table variant="striped" dir="rtl">
          <Tbody>
            <Tr>
              <Td>الاسم</Td>
              <Td>{data?.name}</Td>
            </Tr>
            <Tr>
              <Td>رقم الهاتف</Td>
              <Td>{data?.phone}</Td>
            </Tr>
            <Tr>
              <Td>كلمة المرور</Td>
              <Td>{data?.password}</Td>
            </Tr>
          </Tbody>
        </Table>
      </TableContainer>
    </MainModel>
  );
};

export default ShowAssistantData;

